import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useInfiniteQuery, UseInfiniteQueryResult } from "react-query";
import { fetchChurchVideoSermons } from "../../lib/api/churches";

import { fetchVideoSermons, searchVideoSermons } from "../../lib/api/sermons";
import { PaginatedQuery } from "../types";

const getQueryKey = (query: string, churchId?: string) => {
  if (!!churchId) {
    return query.length > 1
      ? ["sermons", "video", { query, churchId }]
      : ["sermons", "video", { churchId }];
  }
  return query.length > 1 ? ["sermons", "video", { query }] : ["sermons", "video"];
};

function _usePaginatedVideoSermons(
  searchTerm = "",
  churchId?: string
): UseInfiniteQueryResult<ApiResponse<Videos>, AxiosError> {
  return useInfiniteQuery<ApiResponse<Videos>, AxiosError>(
    getQueryKey(searchTerm, churchId),
    ({ pageParam = 0 }) => {
      if (searchTerm?.length > 1) {
        return searchVideoSermons(searchTerm, pageParam);
      } else if (!!churchId) {
        return fetchChurchVideoSermons(churchId, pageParam);
      } else {
        return fetchVideoSermons(pageParam);
      }
    },
    {
      getNextPageParam: lastPage => {
        const currentPage = lastPage.paging?.currentPage;
        if (lastPage.data?.length > 9) {
          return parseInt(currentPage) + 1;
        }
        return undefined;
      }
    }
  );
}

export default function usePaginatedVideoSermons(
  searchTerm = "",
  churchId?: string
): PaginatedQuery<Videos> {
  const [sermons, setSermons] = useState<Videos>([]);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isError,
    isFetchingNextPage
  } = _usePaginatedVideoSermons(searchTerm, churchId);

  useEffect(() => {
    let _items: Videos = [];

    data?.pages?.map(page => {
      _items = [..._items, ...page.data];
    });

    setSermons(_items);
  }, [data]);

  return {
    data: sermons,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isError,
    isFetchingNextPage
  };
}
